{
  "version": 1,
  "asset_id": "369a4a6b-af65-4471-8331-f59f287bad4c",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/369a4a6b-af65-4471-8331-f59f287bad4c/palworld-trial-deck-red-blue-trim.png",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/369a4a6b-af65-4471-8331-f59f287bad4c/palworld-trial-deck-red-blue-trim.png",
  "original_filename": "palworld-trial-deck-red-blue-trim.png",
  "size": 719362,
  "content_type": "image/png",
  "created_at": "2026-08-02T02:01:57Z"
}
